import { motion } from 'framer-motion';
import { FileText, Clock, CreditCard, Car, XCircle, PhoneCall, Scales } from '@phosphor-icons/react';

export default function CGV() {
  const articles = [
    { icon: FileText, title: 'Article 1 – Objet', content: 'Les présentes CGV régissent les relations entre PARIS VTC (DestiDriving) et tout client réservant une prestation de transport VTC via destidriving.fr.' },
    { icon: Clock, title: 'Article 2 – Réservation', content: 'La réservation est effective après remplissage du formulaire en ligne et acceptation des présentes CGV. Un email de confirmation est envoyé au client.' },
    { icon: CreditCard, title: 'Article 3 – Tarifs et paiement', content: 'Les prix affichés sont TTC, payables en ligne par carte bancaire. Aucun paiement en espèces n’est accepté à bord. Une facture est envoyée par email.' },
    { icon: Car, title: 'Article 4 – Prestation', content: 'DestiDriving fournit un véhicule et un chauffeur professionnel à l’heure et au lieu convenus. Un délai de grâce de 15 minutes est accordé au client. Passé ce délai, la course est due intégralement.' },
    { icon: XCircle, title: 'Article 5 – Annulation', content: 'Annulation gratuite jusqu’à 2 heures avant l’heure de prise en charge. En deçà de 2h ou en cas de no-show, la totalité du montant est due. En cas d’imprévu majeur de notre part, nous remboursons intégralement ou proposons un remplacement.' },
    { icon: PhoneCall, title: 'Article 6 – Obligations du client', content: 'Il est interdit de fumer, manger ou boire (hors eau) dans le véhicule. Le client est responsable de tout dégât causé à bord.' },
    { icon: Scales, title: 'Article 7 – Litiges', content: 'Les présentes CGV sont régies par le droit français. En cas de litige, une solution amiable sera recherchée. À défaut, les tribunaux compétents de Bobigny seront saisis.' },
  ];

  return (
    <div className="pt-20" data-testid="cgv-page">
      <section className="py-24 md:py-32">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <p className="text-xs uppercase tracking-[0.2em] text-desti-gold mb-3">Cadre légal</p>
            <h1 className="font-heading text-3xl sm:text-4xl text-white mb-2">Conditions Générales de Vente</h1>
            <p className="text-sm text-desti-text mb-10">Dernière mise à jour : 13 mai 2026</p>
          </motion.div>

          <div className="space-y-6">
            {articles.map((article, idx) => (
              <motion.div
                key={article.title}
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.05 }}
                className="border-b border-white/10 pb-5 last:border-0"
              >
                <div className="flex items-start gap-3">
                  <article.icon size={22} weight="duotone" className="text-desti-gold flex-shrink-0 mt-0.5" />
                  <div>
                    <h2 className="font-heading text-lg text-white mb-1">{article.title}</h2>
                    <p className="text-desti-text text-sm leading-relaxed">{article.content}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mt-12 p-5 bg-desti-gold/10 border-l-2 border-desti-gold"
          >
            <p className="text-sm text-desti-text">
              <strong className="text-white">Service client :</strong> Pour toute réclamation, écrivez à <a href="mailto:contact@destidriving.fr" className="text-desti-gold hover:underline">contact@destidriving.fr</a>. Nous accusons réception sous 48h ouvrés.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
}